import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { EjariContractContext, updateContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import FormAction from "@my-dld/components/Form/FormAction";
import FormRow from "@eres/forms-web/FormRow";
import { populateLookupOnTo } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { Lookup } from "@eres/ejari-api/Entity";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { navigate } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {

}

export interface HazardsState extends LoadableDataState {
	hazardousMaterials: Lookup[];
	selectedIDs: number[];
}

export const HazardsLookupCache: { hazardousMaterials?: Lookup[] } = {};

class HazardsInfo extends Component<Props, HazardsState> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
			hazardousMaterials: [],
			selectedIDs: [],
		};
	}

	componentDidMount() {
		const state: Partial<HazardsState> = {};
		state.selectedIDs = this.context.hazardIds ?? [];
		if ( HazardsLookupCache.hazardousMaterials == null || HazardsLookupCache.hazardousMaterials.length == 0 ) {
			populateLookupOnTo( EjariLookUp.HAZARDS_MAT_CLASSIFICATION, {
				onLookup: ( lookup: EjariLookUp | string, values: Lookup[] ) => {
					HazardsLookupCache.hazardousMaterials = values;
					state.hazardousMaterials = values;
					state.loadState = "done";
					this.setState( state as HazardsState );
				}
			} );
		} else {
			state.hazardousMaterials = HazardsLookupCache.hazardousMaterials;
			state.loadState = "done";
			this.setState( state as HazardsState );
		}
	}

	render() {
		const { selectedIDs } = this.state;
		return <>
			<RenderHazardMaterials state={ this.state } onClick={ this.onClick }/>
			<FormRow>
				<FormAction
					disablePrimaryAction={ selectedIDs.length === 0 }
					groupClassName={ "text-center" }
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
		</>;
	}

	private onClick = ( hazard: Lookup, isSelected: boolean ) => {
		const { selectedIDs } = this.state;
		if ( isSelected ) {
			this.setState( {
				selectedIDs: selectedIDs.filter( id => id !== hazard.Id ),
			} );
		} else {
			this.setState( {
				selectedIDs: [ ...selectedIDs, hazard.Id ],
			} );
		}
	};

	private onContinue = () => {
		updateContractContext( {
			hazardIds: this.state.selectedIDs,
		} );
		navigate( "payment" );
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export function RenderHazardMaterials( props: {
	state: HazardsState,
	onClick: ( hazard: Lookup, isSelected: boolean ) => void
} ) {
	const { state, onClick } = props;
	const { loadState, hazardousMaterials, selectedIDs } = state;
	return <FormSection title={ Strings.hazardous_material_classification }>
		{ loadState === "loading" && <span className="spinner-border"/> }
		{ hazardousMaterials.length > 0 && <ul className="hazard-list row">
			{ hazardousMaterials.map( ( hazard: Lookup ) => {
				const selected = selectedIDs.includes( hazard.Id );
				return <li className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                    <div key={`hazard_item_${hazard.Id}`} className="form-check" onClick={e => {
                        e.preventDefault();
                        onClick(hazard, selected);
                    }}>
                        <input style={{ pointerEvents: "none" }} className="form-check-input" type="checkbox" checked={selected} readOnly={true}/>
                        <label className="form-check-label" htmlFor={`hazard_item_${hazard.Id}`}>
                            {getLocalValue(hazard)}
                        </label>
                    </div>
				</li>;
			} ) }
		</ul> }
	</FormSection>;
}

export default HazardsInfo;
